// utils/audioPlayer/lpClick.ts — beep klik CTA Landing Page (semua user login,
// suara saja tanpa toast). Dipakai useLpClickSound.ts.
import { getAudioContext, loadBuffer, playBeepFallback } from './context.js';

// ─── Beep klik LP ──────────────────────────────────────────────────────────
// Dipakai dashboard: setiap ada pengunjung klik CTA di Landing Page, semua user
// login dengar SATU beep (1 baris `lp_click_events` = 1 beep),
// suara saja — tanpa toast/browser notif (permintaan 2026-10-24).
// File opsional `/sounds/lp-click.mp3` (mis. Pixabay "Beep Beep"); bila belum
// ada, fallback oscillator 2-nada — tetap bunyi tanpa aset & tanpa lisensi.

const _lpClickCache = { buffer: null as AudioBuffer | null };
let lpClickFileMissing = false;

export async function playLpClickSound(volume: number = 0.7): Promise<void> {
  try {
    if (!lpClickFileMissing) {
      const ctx = await getAudioContext();
      if (ctx.state !== 'running') {
        console.warn('[audio] AudioContext suspended saat klik LP — klik di mana saja dulu.');
      }
      const buffer = await loadBuffer('/sounds/lp-click.mp3', _lpClickCache);
      if (buffer) {
        const source = ctx.createBufferSource();
        const gainNode = ctx.createGain();
        source.buffer = buffer;
        gainNode.gain.value = volume;
        source.connect(gainNode);
        gainNode.connect(ctx.destination);
        source.start(0);
        return;
      }
      lpClickFileMissing = true; // 404 → jangan fetch berulang tiap klik
    }
    await playBeepFallback(volume);
  } catch { /* suara tidak tersedia → jangan ganggu UI */ }
}
